import * as React from 'react';
import { translate } from 'react-i18next';
import MessageBox from './MessageBox';
import { Modal } from 'wix-style-react';
var PriceQuoteDialog = function (_a) {
    var onClose = _a.onClose, isOpen = _a.isOpen, businessName = _a.businessName, _b = _a.withInvoice, withInvoice = _b === void 0 ? false : _b, t = _a.t;
    return (React.createElement(Modal, { shouldCloseOnOverlayClick: true, isOpen: isOpen, onRequestClose: onClose, contentLabel: '' },
        React.createElement(MessageBox, { businessName: businessName, onClose: onClose, withInvoice: withInvoice })));
};
export default translate(['invoice-view', 'locale-data'], { wait: true })(PriceQuoteDialog);
//# sourceMappingURL=PriceQuoteDialog.js.map